import { TeamMemberRole } from '__generated__/GQL';

export const FREE_ROLES = [TeamMemberRole.Accountant];
